import { index, integer, pgTable, text, timestamp } from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";

export const chatSnippets = pgTable(
  "chat_snippets",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    title: text("title").notNull(),
    body: text("body").notNull(),
    sortOrder: integer("sort_order").notNull().default(0),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [index("chat_snippets_by_sort").on(t.sortOrder)],
);

export const shopSettings = pgTable("shop_settings", {
  key: text("key").primaryKey(),
  value: text("value").notNull(),
  updatedAt: timestamp("updated_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
});

export const SHOP_SETTING_KEYS = [
  "shop_display_name",
  "shop_phone",
  "bank_name",
  "bank_account_number",
  "bank_account_name",
  "order_summary_template",
] as const;

export type ShopSettingKey = (typeof SHOP_SETTING_KEYS)[number];
